import { render, staticRenderFns } from "./CloundProvider.vue?vue&type=template&id=8f2fb0b0&"
import script from "./CloundProvider.vue?vue&type=script&lang=ts&"
export * from "./CloundProvider.vue?vue&type=script&lang=ts&"
import style0 from "./CloundProvider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports